import React from 'react'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import { useFetchList } from 'store'
import ProcessProviderHistory from 'models/ProcessProviderHistory'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'

import styles from './HistoryDialog.module.sass'
import NoData from 'components/general/NoData/NoData'

const ProviderHistoryRow = (props) => {
	const { data, i18n, screenSize } = props
	const { startDate, endDate, establishment } = data

	return (
		<HStack className={styles['history-row']}>
			{screenSize !== 'small' ? (
				<small className={styles['date-column']}>
					<strong>{`${startDate?.shortDateFormat} - ${
						endDate?.shortDateFormat || i18n`the moment`
					}`}</strong>
				</small>
			) : (
				<small>
					<VStack>
						<strong className={styles['date-column']}>
							{startDate?.shortDateFormat}
						</strong>
						<strong>
							{endDate?.shortDateFormat || i18n`the moment`}
						</strong>
					</VStack>
				</small>
			)}
			<small>{establishment?.name?.trim()}</small>
		</HStack>
	)
}

const ProviderHistoryDialog = (props) => {
	const { data } = props
	const { processId } = data
	const { i18n, screenSize } = useGlobal()

	const {
		contents: [processProviderHistory],
		state,
	} = useFetchList(
		[`/clinical_processes/${processId}/provider_history`],
		[ProcessProviderHistory.fromJSON]
	)

	const isLoading = state === 'loading'
	return !isLoading ? (
		processProviderHistory?.length ? (
			<VStack className={styles['history-root']}>
				<VStack className={styles['history-container']}>
					{processProviderHistory.map((providerHistory, key) => (
						<ProviderHistoryRow
							key={key}
							i18n={i18n}
							screenSize={screenSize}
							data={providerHistory}
						/>
					))}
				</VStack>
			</VStack>
		) : (
			<NoData
				applyMaxWidth
				paddings={['normal', 'normal']}
				message={i18n`This process has no extra data to show.`}
			/>
		)
	) : (
		<VStack className={styles['center-content']} justify='space-between'>
			<Icon name='on-going' />
			<small>{i18n`Loading provider history...`}</small>
		</VStack>
	)
}

export default ProviderHistoryDialog
